import adminApi from './plugins/admin-api';

const supportFormComponent = () => ({
    submitting: false,
    confirmation: false,
    highlighted: false,
    networkError: false,
    filesIncomplete: false,
    filesError: false,


    errors: {},
    name: '',
    email: '',
    email_confirmation: '',
    message: '',
    files: [],
    filesIdCounter: 0,


    // FILE METHODS
    attachFiles(e) {
        if (e.target.files.length) {
            this.handleFiles([...e.target.files]);
        }
        e.target.value = ""; // Reset input
    },

    async handleFiles(files) {
        files.forEach((f) => {
            let file = Alpine.reactive({
                id: this.filesIdCounter++,
                name: f.name,
                size: f.size,
                type: f.type,
                key: "",
                signed_url: "",
                progress: 0,
                complete: false,
                failed: false,
                cancel: () => {},
            });
            (async () => {
                try {
                    const ref = await this.createFileReference(file.name);
                    file.key = ref.key;
                    file.signed_url = ref.signed_url;
                    await this.uploadFile(f, file);
                } catch (e) {
                    file.failed = true;
                    console.error(e);
                }
            })();

            this.files.push(file);
        });
    },

    async createFileReference(name) {
        const recaptcha_token = await grecaptcha.execute(process.env.MIX_RECAPTCHA_KEY, {action: 'marketing/support_form/file'});

        const { data } = await adminApi.post("/product-care/support-requests/files", {
            name: name,
            recaptcha: recaptcha_token,
        });

        return data;
    },

    async uploadFile(file, ref) {
        const source = axios.CancelToken.source();

        ref.cancel = () => {
            source.cancel("File upload canceled by user");
        };

        const res = await axios.put(ref.signed_url, file, {
            headers: {
                "Content-Type": file.type,
            },
            cancelToken: source.token,
            onUploadProgress: (progressEvent) => {
                ref.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            },
        });

        ref.complete = true;

        return res;
    },

    deleteFile(i) {
        const file = this.files[i];
        if (!file.complete) file.cancel();
        this.files.splice(i, 1);
    },

    formatBytes(bytes, decimals = 2) {
        if (bytes === 0) return "0 Bytes";

        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    },

    // SUBMIT METHOD
    async submitSupportForm () {
        if (this.files.filter((file) => file.failed).length) {
            this.filesError = true;
            this.errors = { fileserror: 'Files failed to upload' };
            return;
        }

        if (this.files.filter((file) => !file.failed && !file.complete).length) {
            this.filesIncomplete = true;
            this.errors = { filesincomplete: 'Incomplete file upload' };
            return;
        }

        this.submitting = true;
        this.errors = {};

        let recaptcha_token;
        try {
            recaptcha_token = await grecaptcha.execute(process.env.MIX_RECAPTCHA_KEY, {action: 'marketing/support_form/submit'});
        } catch (e){
            this.submitting = false
        }
        
        if (!recaptcha_token) {
            this.submitting = false
        }
        
        try {
            const {data} = await adminApi.post('/product-care/support-requests', {
                category: 'education',
                name: this.name,
                email: this.email,
                email_confirmation: this.email_confirmation,
                message: this.message,
                files: this.files.filter((file) => file.complete && !file.failed).map((file) => ({ name: file.name, key: file.key })), 
                recaptcha: recaptcha_token,
            });

            this.confirmation = true;
        } catch (e) {
            this.submitting = false;

            if (e.response.data) {
                this.errors = (e.response.data.errors);
            } else {
                this.networkError = true;
                this.errors = { network: e.message };
            }
        }
        
        this.submitting = false;
        
    },

    //DRAG AND DROP EVENT METHODS
    initDropzone() {
        ["drag", "dragstart", "dragend", "dragover", "dragenter", "dragleave", "drop"].forEach((eventName) => {
            document.addEventListener(eventName, this.preventDefaults, false);
        });

        document.addEventListener("dragenter", (e) => this.handleDragEnter(e), false);
        document.addEventListener("dragleave", (e) => this.handleDragLeave(e), false);
        document.addEventListener("drop", (e) => this.handleDrop(e), false);
    },

    handleDragEnter() {
        this.highlighted = true;
    },

    handleDragLeave(event) {
        if (event.screenY <= 0 && event.screenX <= 0) {
            this.highlighted = false;
        }
    },

    handleDrop(event) {
        this.highlighted = false;

        if (event.dataTransfer.files.length) {
            this.handleFiles([...event.dataTransfer.files]);
        }
    },

    preventDefaults(event) {
        event.preventDefault();
        event.stopPropagation();
    },

})

window.supportFormComponent = supportFormComponent;